import { Instagram, Youtube, Linkedin, Lock } from "lucide-react";
import { openTrackedLink } from "../../lib/api";

export default function SiteFooter({ settings }) {
  const socials = [
    { icon: Instagram, url: settings.instagram_url, name: "Instagram" },
    { icon: Youtube, url: settings.youtube_url, name: "YouTube" },
    { icon: Linkedin, url: settings.linkedin_url, name: "LinkedIn" },
  ];
  return (
    <footer className="mt-16 border-t border-white/10 pt-10 text-center">
      <div className="flex items-center justify-center gap-3">
        {socials.map((s) => (
          <button
            key={s.name}
            onClick={() => openTrackedLink(s.url, { item_type: "social", item_name: `Footer ${s.name}` })}
            aria-label={s.name}
            data-testid={`footer-social-${s.name.toLowerCase()}`}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white transition-all hover:bg-white hover:text-[#1d1d1b]"
          >
            <s.icon size={17} />
          </button>
        ))}
      </div>

      <a
        href={`mailto:${settings.email}`}
        className="mt-5 block text-lg font-semibold text-white"
        data-testid="footer-email"
      >
        {settings.email}
      </a>

      <div className="mx-auto mt-6 max-w-md space-y-3 text-[11px] leading-relaxed text-white/45">
        <p>
          <span className="font-semibold text-white/70">Affiliate disclosure:</span> Some links on
          this page may be affiliate links. I may receive a commission when you apply or purchase
          through them, at no additional cost to you.
        </p>
        <p>
          <span className="font-semibold text-white/70">Credit-card disclaimer:</span>{" "}
          Credit-card benefits, fees, eligibility requirements and offers may change. Please verify
          the latest terms with the relevant bank before applying.
        </p>
      </div>

      <p className="mt-6 text-[11px] text-white/40">
        © {new Date().getFullYear()} {settings.name} · ThatCreditCardGuy. All rights reserved.
      </p>

      <a
        href="/admin"
        data-testid="footer-admin-link"
        className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-medium text-white/40 transition-colors hover:text-white/80"
      >
        <Lock size={11} /> Go to Admin
      </a>
    </footer>
  );
}
